export const DELIMETER_KEYWORD = 'DELIMETER'
